var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"10","opacity":"0.9"}},[_c('div',{staticClass:"overlay-loader"},[_c('v-progress-circular',{staticClass:"mb-2",attrs:{"indeterminate":"","size":"50","color":"primary"}}),_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(!!_vm.text ? _vm.text : 'Sincronizando...'))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }